<template>
    <!-- <Layout> -->
    <div>
        <Head>
            <title>Discover Rothco</title>
            <meta name="description" :content="cmsContent.data.metaDescription" />
            <meta name="keywords" :content="cmsContent.data.metaKeywords" />
        </Head>
        <Cms
            content-prop="cmsContent"
            model="content-section"
            :search-params="searchParams"
            driver="builder"
            is-section
            :components="getBuilderComponents()"
        />
    </div>
    <!-- </Layout> -->
</template>
<script setup lang="ts">
    import Cms from "@/components/Cms.vue";
    import { computed } from "vue";
    import { getBuilderComponents } from "@root/builder-components.ts";
    import { Head } from "@inertiajs/vue3";
    let props = defineProps({
        cmsContent: {
            type: Object,
            default: () => ({
                data: {
                    pageName: null,
                    metaDescription: "",
                    metaKeywords: ""
                }
            })
        }
    })

    let searchParams = computed(()=>({
        "data.pageUrl.$eq": "discover-rothco"
    }))
</script>
